/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { viewConcern, updateViewConcern } from '../../service/todo';
import moment from 'moment';
import './css/Concern-form.css';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import { NotificationTrigger } from '../../utils/RegHandling';
import Loader from '../../StaticComponent/Loader';
import { connect } from 'react-redux';
import { encryptStorage } from '../../constant';
import { selectClickedNotification } from '../../service/api';

function ConcernView({ websocket }) {
    let date, victim, statusColor, role;
    let Role = encryptStorage.getItem('role');
    let roleId = encryptStorage.getItem('employeeId');
    let { state } = useLocation();

    const navigate = useNavigate();
    const [concernDetails, setConcernDetails] = useState([]);
    const [concernStatus, setConcernStatus] = useState();
    const [oldconcernStatus, setoldconcernStatus] = useState();
    const [disabledCheck, setDisabledCheck] = useState(false);
    const [formattedDate, setFormattedDate] = useState('');
    const [way, setWay] = useState(state?.concern?.way);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        // if (localStorage.getItem('NotificationId') != undefined && !state) {
        if (!state) {
            state = JSON.parse(localStorage.getItem('NotificationState'))?.state;
            setWay(state?.concern?.way);
        }

        // loadStateFromNotificaiton()
        // } 
        loadConcern();
    }, [state]);
    const loadStateFromNotificaiton = async () => {
        let response = await selectClickedNotification();
        let stateObject = response.data.ResponseData[0].state;
        setWay(stateObject.state.way)
        state = stateObject.state
    }

    useEffect(() => {
        if (oldconcernStatus == concernStatus) setDisabledCheck(true);
        else setDisabledCheck(false);
    }, [concernStatus, oldconcernStatus, disabledCheck]);

    if (Role == 'Hr' || Role == 'Hr Manager') {
        role = 'Hr Manager';
    } else {
        role = Role;
    }

    const loadConcern = async () => {
        try {
            setIsLoading(false);
            let detailsArray = await viewConcern(state?.concern);
            setConcernDetails(detailsArray?.data);
            setConcernStatus(detailsArray?.data[0]?.status);
            setoldconcernStatus(detailsArray?.data[0]?.status);

            let m = moment(new Date(detailsArray?.data?.body?.data[0]?.incident_date));
            date = m.format('MMM DD, YYYY');
            setFormattedDate(date);
            setIsLoading(true);
        } catch (error) { }
    };

    const handleChange = (e) => {
        setConcernStatus(e.target.value);
    };

    const submitClick = async () => {
        ;
        let concernData = {};
        if (localStorage.getItem('NotificationState')) {
            state = JSON.parse(localStorage.getItem('NotificationState'))?.state;
             concernData = {
                type: state?.concern.type,
                concern_id: state?.concern.concern_id,
                status: concernStatus,
            };
        }
        else {
             concernData = {
                 type: state?.concern.type,
                 concern_id: state?.concern.concern_id,
                 status: concernStatus,
             };
            
        }      
        setIsLoading(false);
        let response = await updateViewConcern(concernData);

        setIsLoading(true);

        if (response?.message == 'Data Updated Successfully') {
            if (concernDetails[0].concern_type) {
                NotificationTrigger(
                    {
                        title: 'Concern',
                        message: `Your concern status has been changed to ${concernData.status}`,
                        /* route: `leavewfh/` , */
                        route: `/concernview`,
                        state: { state: { concern: { type: concernData.type, concern_id: concernData.concern_id, way: way } } },
                        to_employee: [response?.empId],
                        by: roleId,
                    },
                    [response?.empId],
                    websocket
                ).then((res) => {
                    redirect();
                });
            }
            // else if (concernDetails[0].concern_type.toLowerCase().includes("lead") || concernDetails[0].concern_type.toLowerCase().includes("harassment")) {

            //     NotificationTrigger({
            //         title: "Concern", message: `${concernData.status} the Concern`,
            //         /* route: `leavewfh/` , */
            //         route: `/concerns`,
            //         to_employee: [response?.data.body.empId],
            //         by: roleId
            //     }, [response?.data.body.empId]).then(res =>

            //         redirect()
            //     )

            // }
        }
    };

    const redirect = () => {
        navigate(`/concerns`, { state: { way: way } });
    };

    if (concernDetails[0]?.victim == '1') {
        victim = 'Myself';
    } else {
        victim = 'My Friend';
    }

    if (concernDetails[0]?.status == 'Pending') {
        statusColor = `bg-pastel-orange`;
    } else if (concernDetails[0]?.status == 'Solved') {
        statusColor = `bg-pastel-green`;
    } else {
        statusColor = `bg-pastel-red`;
    }

    let breadCrumbsData;
    if (role == 'Team Member') {
        breadCrumbsData = [
            { title: 'Dashboard', path: '/Overview', isActive: true },
            { title: 'How Do I', path: ``, isActive: true },
            { title: `${concernDetails[0]?.raised_by}`, path: '', isActive: false },
        ];
    } else {
        breadCrumbsData = [
            { title: 'Dashboard', path: '/Overview', isActive: true },
            { title: 'Team Member', path: ``, isActive: true },
            { title: 'Concerns', path: `/concerns`, isActive: true },
            { title: `${concernDetails[0]?.raised_by}`, path: '', isActive: false },
        ];
    }

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="container-fluid coverpic bg-light  mt-5">
                <div className="row justify-content-center ">
                    <div className="col-md-9 p-4 mt-5 bg-white rounded-3">
                        <BreadCrumbs data={breadCrumbsData} />
                        <p className="fontsize15 tt-bold">Concern</p>
                        <div className="row">
                            <div className="col-md-4">
                                <label className="form-label hive-form-label mb-2">What is your concern about? </label>
                                <p className="font-14 bold-text concern-form-label">{concernDetails[0]?.concern_type}</p>
                            </div>
                            <div className="col-md-4">
                                <p className="form-label hive-form-label mb-2">Concern by</p>
                                <div className="d-flex align-items-center">
                                    <img src="/Images/Ananymous.svg" className="concern-user-profile me-2" alt="user-image" />
                                    <div>
                                        <a className="font-12 semibold-text team-member-name mb-0 text-decoration-none">
                                            {concernDetails[0]?.raised_by}
                                        </a>
                                        <p className=" font-13 regular-text mb-0 concern-text-color">{concernDetails[0]?.r_role}</p>
                                    </div>
                                </div>
                            </div>
                            {roleId === concernDetails[0]?.emp_id || roleId === concernDetails[0]?.raised_by_id ? (
                                <div class="col-md-4">
                                    <p class="form-label hive-form-label mb-2">Concern Status</p>
                                    <div class="d-flex align-items-center">
                                        <span class={`status-btn ${statusColor} font-12`}>{concernDetails[0]?.status}</span>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    {state?.concern?.type != '3' ? (
                        <div className="col-md-9 p-4 bg-white mt-4 rounded-3" style={{ marginBottom: '95px' }}>
                            <div className="row mb-4">
                                <div className="col-md-4">
                                    <p className="form-label hive-form-label mb-2">Department</p>
                                    <div className="d-flex align-items-center">
                                        <img src="/Images/People.svg" className="concern-team-profile me-2 mt-2" alt="Department" />
                                        <p className="font-15 semibold-text concern-department-color mb-0 mt-2">
                                            {concernDetails[0]?.department_id}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <p className="form-label hive-form-label mb-2">Feedback About whom?</p>
                                    <div className="d-flex align-items-center">
                                        {concernDetails?.map((obj) => {
                                            return (
                                                <>
                                                    <img
                                                        src="/Images/Ananymous.svg"
                                                        className="concern-user-profile me-2"
                                                        alt="person-profile"
                                                    />
                                                    <div>
                                                        <a className="font-13 semibold-text team-member-name mb-0 text-decoration-none">
                                                            {obj.againstto}
                                                        </a>
                                                        <p className=" font-13 regular-text mb-0 concern-text-color">{obj.againsttorole}</p>
                                                    </div>
                                                </>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-4">
                                <label className="form-label hive-form-label mb-2">Feedback</label>
                                <p className="font-13 medium-text text-break concern-description-color mb-0">
                                    {concernDetails[0]?.description}
                                </p>
                            </div>
                            <div className="row mb-5">
                                <div hidden={roleId != concernDetails[0]?.emp_id ? false : true} className="col-md-3">
                                    <label htmlFor="concern-status" className="form-label hive-form-label mb-2">
                                        Concern Status <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        onChange={(e) => {
                                            handleChange(e);
                                        }}
                                        value={concernStatus}
                                        name="status"
                                        className="custom-textfield form-select hive-form-select"
                                        id="concern-status"
                                        disabled={
                                            concernDetails[0]?.status.toLowerCase() == 'closed' ||
                                                concernDetails[0]?.status.toLowerCase() == 'solved'
                                                ? 'true'
                                                : ''
                                        }
                                        aria-label="Default select example"
                                    >
                                        <option value={`Pending`}>Pending</option>
                                        <option value={`Solved`}>Solved</option>
                                        <option value={`Closed`}>Closed</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-12 d-flex justify-content-end mb-4">
                                <button
                                    onClick={() => {
                                        redirect();
                                    }}
                                    className="btn hive-btn-secondary bold-text me-2"
                                >
                                    Cancel
                                </button>
                                {roleId === concernDetails[0]?.emp_id ||
                                    roleId === concernDetails[0]?.raised_by_id ||
                                    concernDetails[0]?.status.toLowerCase() == 'closed' ||
                                    concernDetails[0]?.status.toLowerCase() == 'solved' ? null : role === 'Hr Manager' || role === 'Manager' ? (
                                        <button
                                            disabled={disabledCheck == true ? true : false}
                                            onClick={() => {
                                                submitClick();
                                            }}
                                            className="btn hive-btn-primary"
                                        >
                                            Save
                                        </button>
                                    ) : null}
                            </div>
                        </div>
                    ) : (
                        <div className="col-md-9 p-4 bg-white mt-4 rounded-3" style={{ marginBottom: '95px' }}>
                            <div className="row mb-4">
                                <div className="col-md-12">
                                    <label className="form-label hive-form-label mb-2">Who is the Victim? </label>
                                    <p className="font-14 bold-text concern-form-label">{victim}</p>
                                </div>
                                {concernDetails[0]?.victim == 1 ? (
                                    <>
                                        <div className="col-md-4">
                                            <p className="form-label hive-form-label mb-2">People Involved in the Incident</p>
                                            <div className="d-flex align-items-center">
                                                {concernDetails?.map((obj) => {
                                                    return (
                                                        <>
                                                            <img
                                                                src="/Images/Ananymous.svg"
                                                                className="concern-user-profile me-2"
                                                                alt="person-profile"
                                                            />
                                                            <div>
                                                                <a className="font-13 semibold-text team-member-name mb-0 text-decoration-none">
                                                                    {obj.againstto}
                                                                </a>
                                                                <p className=" font-13 regular-text mb-0 concern-text-color">
                                                                    {obj.againsttorole}
                                                                </p>
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label hive-form-label mb-2">Date</label>
                                            <p className="font-14 semibold-text concern-department-color">{formattedDate}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label hive-form-label mb-2">Location</label>
                                            <p className="font-14 semibold-text text-break concern-department-color">
                                                {concernDetails[0]?.location}
                                            </p>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="col-md-4">
                                            <p className="form-label hive-form-label mb-2">Department</p>
                                            <div className="d-flex align-items-center">
                                                <img src="/Images/People.svg" className="concern-team-profile me-2 mt-2" alt="Department" />
                                                <p className="font-15 semibold-text concern-department-color mb-0 mt-2">
                                                    {concernDetails[0]?.department_id}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label hive-form-label mb-2">Friend Name</label>
                                            <p className="font-14 bold-text concern-form-label">{concernDetails[0]?.victim_name}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <p className="form-label hive-form-label mb-2">People Involved</p>
                                            <div className="d-flex align-items-center">
                                                {concernDetails?.map((obj) => {
                                                    return (
                                                        <>
                                                            <img
                                                                src="/Images/Ananymous.svg"
                                                                className="concern-user-profile me-2"
                                                                alt="person-profile"
                                                            />
                                                            <div>
                                                                <a className="font-13 semibold-text team-member-name mb-0 text-decoration-none">
                                                                    {obj.againstto}
                                                                </a>
                                                                <p className=" font-13 regular-text mb-0 concern-text-color">
                                                                    {obj.againsttorole}
                                                                </p>
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label hive-form-label mb-2">Location</label>
                                            <p className="font-14 bold-text concern-form-label">{concernDetails[0]?.location}</p>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="col-md-12 mb-4">
                                <label className="form-label hive-form-label mb-2">Description of the Incident</label>
                                <p className="font-13 medium-text text-break concern-description-color mb-0">
                                    {concernDetails[0]?.description}
                                </p>
                            </div>
                            {way == 0 ? null : (
                                <div className="row mb-5">
                                    <div
                                        hidden={roleId != concernDetails[0]?.emp_id && role != 'Manager' ? false : true}
                                        className="col-md-3"
                                    >
                                        <label htmlFor="concern-status" className="form-label hive-form-label mb-2">
                                            Concern Status <span className="hive-form-mandatory">*</span>
                                        </label>
                                        <select
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            value={concernStatus}
                                            name="status"
                                            className="custom-textfield form-select hive-form-select"
                                            id="concern-status"
                                            disabled={
                                                concernDetails[0]?.status.toLowerCase() == 'closed' ||
                                                    concernDetails[0]?.status.toLowerCase() == 'solved'
                                                    ? 'true'
                                                    : ''
                                            }
                                            aria-label="Default select example"
                                        >
                                            <option value={`Pending`}>Pending</option>
                                            <option value={`Solved`}>Solved</option>
                                            <option value={`Closed`}>Closed</option>
                                        </select>
                                    </div>
                                </div>
                            )}
                            <div className="col-md-12 d-flex justify-content-end mb-4">
                                <button
                                    onClick={() => {
                                        redirect();
                                    }}
                                    className="btn hive-btn-secondary bold-text me-2"
                                >
                                    Back
                                </button>
                                {roleId === concernDetails[0]?.emp_id ||
                                    roleId === concernDetails[0]?.raised_by_id ||
                                    concernDetails[0]?.status.toLowerCase() == 'closed' ||
                                    concernDetails[0]?.status.toLowerCase() == 'solved' ? null : role === 'Hr Manager' ? (
                                        <button
                                            onClick={() => {
                                                submitClick();
                                            }}
                                            className="btn hive-btn-primary"
                                        >
                                            Save
                                        </button>
                                    ) : null}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI,
    };
}
export default connect(mapStateToProps)(ConcernView);
